var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: { title: _vm.$t("dayEndClosing"), hideRgtBtn: "", large: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { "py-0": "", fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { "align-baseline": "", row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "" } },
                      [
                        _c(
                          "v-layout",
                          { attrs: { "align-end": "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { "mr-2": "", xs3: "" } },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    ref: "datePicker",
                                    attrs: {
                                      "close-on-content-click": false,
                                      "nudge-right": 40,
                                      lazy: "",
                                      transition: "scale-transition",
                                      "offset-y": "",
                                      "full-width": "",
                                      "min-width": "290px"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    value: _vm.date,
                                                    label: _vm.$t(
                                                      "dayEndClosing"
                                                    ),
                                                    "prepend-icon": "event",
                                                    readonly: ""
                                                  }
                                                },
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.datePicker,
                                      callback: function($$v) {
                                        _vm.datePicker = $$v
                                      },
                                      expression: "datePicker"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      attrs: { "no-title": "", scrollable: "" },
                                      model: {
                                        value: _vm.date,
                                        callback: function($$v) {
                                          _vm.date = $$v
                                        },
                                        expression: "date"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { "mx-2": "", xs4: "" } },
                              [
                                _c("v-combobox", {
                                  attrs: {
                                    label: _vm.$t("organizations"),
                                    items: _vm.clients,
                                    chipText: "clientName",
                                    itemText: "clientName",
                                    chips: "",
                                    multiple: "",
                                    clearable: "",
                                    "return-object": ""
                                  },
                                  model: {
                                    value: _vm.selectedClients,
                                    callback: function($$v) {
                                      _vm.selectedClients = $$v
                                    },
                                    expression: "selectedClients"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { "text-xs-right": "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", loading: _vm.isLoading },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.getDayEndClosings()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("search")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              loading: _vm.isLoading,
                              disabled: !_vm.items.length
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.exportDayEndClosings()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("export")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-data-table", {
                          staticClass: "elevation-1",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.items,
                            "item-key": "clientKey",
                            loading: _vm.isLoading,
                            pagination: _vm.pagination
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", { staticClass: "subheading" }, [
                                    _c(
                                      "div",
                                      [
                                        props.item.type === "warehouse"
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "20px"
                                                }
                                              },
                                              [_vm._v("local_shipping")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.item.type === "organization"
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "20px"
                                                }
                                              },
                                              [_vm._v("business")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.item.isBlockCreditCardDeposit
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "20px"
                                                }
                                              },
                                              [_vm._v("strikethrough_s")]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(props.item.clientName) +
                                            "\n                  "
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.companyName))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.balance))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.accountManager))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v("(" + _vm._s(props.item.email) + ")")
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.dayEndBalance))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.toDateYYYYMMDD(
                                            props.item.lastTransactionTime
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44473966", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44473966","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayEndClosingPopup.vue
// module id = null
// module chunks = 